import { Injectable, Inject, forwardRef } from "@angular/core";

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ExpenseExportRequest } from "../../_models/expense-export/expense-export";
import { from, Observable } from "rxjs";
import { ExpenseExportLogRequest } from "src/app/_models/expense-export/expense-export-log";
import { ReportMasterRequest } from "src/app/_models/expense-export/report-master";
import { ReportFieldMappingRequest } from "src/app/_models/expense-export/report-field-mapping";
import { setHeader } from "src/app/_helpers/setRequestHeader";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import {
  ICartDetailsResponse,
  ICartDetailsRequest,
} from "src/app/_models/organisation-setting/organisation-setting";
import { ExportFormatEnum, IApiRequest, IApiresponse } from "src/app/_models";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "../common/claims.service";
import {
  SubmitFeedbackRequest,
  UnsubscribEODRequest,
} from "src/app/_models/support/supportrequest";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class ExpenseExporService {
  orgId: number;
  userId: number;
  organisationCurrency: string;
  claims: Claims;

  httpHeaders: HttpHeaders;
  constructor(
    private header: setHeader,
    private http: HttpClient,
    private claimsService: ClaimsService,
    private claimsHeaderService: ClaimsHeaderService,
    private translate: TranslateService
  ) {
    this.claimsService.currentClaims.subscribe(
      (claims) => (this.claims = claims)
    );
    this.orgId = this.claims.OrgId;
    this.userId = this.claims.UserId;
    this.organisationCurrency = this.claims.CurrentOrganisationCurrency;
  }

  currentExportid: number;
  isNegativeExpense: boolean;
  companyName: string;
  getExportFormat() {
    return this.http.get<any>(`${environment.expenseApiUrl}GetExportFormats`, {
      headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
    });
  }

  getExpensesToExport(
    expenseExportRequests: ExpenseExportRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(expenseExportRequests);
    return this.http
      .post<any>(`${environment.expenseApiUrl}GetExpensesForExport`, body, {
        //.post<any>(`${environment.expenseApiUrl}GetExpensesForExportByCompany`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  sendExportedExpenses(
    expensesToExport: any[],
    token: string
  ): Observable<any> {
    let body = JSON.stringify(expensesToExport);
    return this.http
      .post<any>(`${environment.expenseApiUrl}SendExportedExpenses`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }


  sendExportedExpensesBackground(
    expensesToExport: any[],
    token: string,
  ): Observable<any> {
    let body = JSON.stringify(expensesToExport);
    return this.http
      .post<any>(`${environment.expenseApiUrl}SendExportedExpensesBackground`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  getReportMasterByOrg(
    reportMasterRequest: ReportMasterRequest
  ): Observable<any> {
    let body = JSON.stringify(reportMasterRequest);
    return this.http
      .post<any>(`${environment.exportApiUrl}GetReportMaster`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((reportMasterresponse) => {
          return reportMasterresponse;
        })
      );
  }

  TokenHeader: HttpHeaders;
  getReportFieldMaster(claimantType: number = 0): Observable<any> {
    this.TokenHeader = this.header.authorizationHeader();

    return this.http
      .get<any>(`${environment.exportApiUrl}GetReportFieldMaster`, {
        headers: this.TokenHeader,
      })
      .pipe(
        map((reportFieldMasterresponse) => {
          return reportFieldMasterresponse;
        })
      );
  }

  getReportMappingByMaster(
    reportFieldMappingRequest: ReportFieldMappingRequest
  ): Observable<any> {
    let body = JSON.stringify(reportFieldMappingRequest);
    return this.http
      .post<any>(
        `${environment.exportApiUrl}GetReportFieldMappingByMaster`,
        body,
        {
          headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        }
      )
      .pipe(
        map((reportFieldMappingresponse) => {
          return reportFieldMappingresponse;
        })
      );
  }

  getExpensesExportLog(
    expenseExportLogRequest: ExpenseExportLogRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(expenseExportLogRequest);
    return this.http
      .post<any>(`${environment.expenseApiUrl}GetExpenseExportLog`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getExpensesExportLogByCategory(
    expenseExportLogByCategoryRequest: any,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(expenseExportLogByCategoryRequest);
    return this.http
      .post<any>(
        `${environment.exportApiUrl}GetExportLogDetailByExportId`,
        body,
        {
          headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getExpensesExportLogWithExpenses(
    expenseExportLogByCategoryRequest: any,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(expenseExportLogByCategoryRequest);
    return this.http
      .post<any>(
        `${environment.expenseApiUrl}GetExpenseExportLogWithExpenses`,
        body,
        {
          headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
  }


    uploadReceiptsForXeroMultiLine(exportId) {
    let params = new HttpParams();

    return this.http.get<any>(
      `${environment.exportApiUrl}UploadReceiptsForXeroMultiLine?exportId=${exportId}`,
      {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        params: params,
      }
    );
  }

  checkForEmailVerification(userid: string, token: string) {
    let params = new HttpParams();
    params = params.append("Userid", userid);

    return this.http.get<any>(
      `${environment.billingApiUrl}CheckForEmailVerification`,
      {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        params: params,
      }
    );
  }

  sendVerificationEmail(loginId: string, token: string) {
    let params = new HttpParams();
    params = params.append("EmailId", loginId);
    let body = "{email:loginId}";

    return this.http.get<any>(
      `${environment.billingApiUrl}SendVerificationEmail`,
      {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        params: params,
      }
    );
  }

  SaveCartDetails(
    requestinfo: IApiRequest<ICartDetailsRequest>
  ): Observable<IApiresponse<ICartDetailsResponse>> {
    requestinfo.requestInfo.UserId = this.userId;
    requestinfo.requestInfo.OrganisationId = this.orgId;
    let body = JSON.stringify(requestinfo);
    return this.http.post<IApiresponse<ICartDetailsResponse>>(
      `${environment.catalogApiUrl}SaveCartDetails`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  submitFeedback(
    submitFeedbackRequest: SubmitFeedbackRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(submitFeedbackRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}SubmitFeedback`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  unsubscribeEOD(
    unsubscribEODRequest: UnsubscribEODRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(unsubscribEODRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}UnsubscribeEOD`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  getImportTemplateData(
    reportFieldMappingRequest: any
  ): Observable<any> {
    let body = JSON.stringify(reportFieldMappingRequest);
    return this.http
      .post<any>(
        `${environment.exportApiUrl}UploadFileForImport`,
        body,
        {
          headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
        }
      )
      .pipe(
        map((reportFieldMappingresponse) => {
          return reportFieldMappingresponse;
        })
      );
  }

  fnGetReportFormatName(exportFormatId: number, exportFormatName: string): string {
    switch (exportFormatId) {
      case ExportFormatEnum.Tally:
        return this.translate.instant("tally");
      case ExportFormatEnum.Xero:
        return this.translate.instant("xero");
      case ExportFormatEnum.QuickBooks:
        return this.translate.instant("quickbooks");
      case ExportFormatEnum.Sage50:
        return this.translate.instant("sage_50");
      default:
        return exportFormatName;

    }
  }

  UpdateExportSeperatorPreference(exportSeparatorSelected): Observable<IApiresponse<boolean>> {
    const encodedParam = encodeURIComponent(exportSeparatorSelected);
    return this.http.get<IApiresponse<boolean>>(
      `${environment.billingApiUrl}UpdateExportSeperatorPreference?exportSeparatorSelected=${encodedParam}`,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  UnsubscribeEODApplication(
    unsubscribEODRequest: UnsubscribEODRequest,
    token: string
  ): Observable<any> {
    let body = JSON.stringify(unsubscribEODRequest);
    return this.http
      .post<any>(`${environment.billingApiUrl}UnsubscribeEODApplication`, body, {
        headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
      })
      .pipe(
        map((user) => {
          return user;
        })
      );
  }

  ResubscribeEODApplication(orgId: number): Observable<any> {
  return this.http
    .get<any>(`${environment.billingApiUrl}ResubscribeEODApplication?OrgId=${orgId}`, {
      headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
    })
    .pipe(
      map((response) => {
        return response;
      })
    );
}
}
